/**
 * Układ i działanie klawiatury ekranowej — bez React, żeby dało się to sprawdzić testem.
 *
 * Klawiatura istnieje dla jednego przypadku: pilot telewizora wysyła **strzałki
 * i Enter**, więc na ekranie wyszukiwania nie ma czym wpisać ani jednego znaku.
 * Nawigacja przestrzenna doprowadza fokus do pola i tam się kończy — pole jest
 * ślepym zaułkiem, bo litery nie mają skąd przyjść.
 *
 * Układ jest **alfabetyczny**, nie QWERTY. Przy wybieraniu strzałkami nie ma pamięci
 * mięśniowej, jest szukanie wzrokiem: „gdzie jest `m`" rozstrzyga się w alfabecie
 * w jednym spojrzeniu, a w QWERTY wymaga przeczytania trzech rzędów.
 */

export type KeyAction =
  | { kind: 'char'; char: string }
  | { kind: 'space' }
  | { kind: 'backspace' }
  | { kind: 'clear' };

/**
 * Rzędy po dziesięć znaków.
 *
 * Równa długość rzędów nie jest estetyką: nawigacja liczy cel z geometrii, więc rząd
 * krótszy o dwa klawisze zsuwałby fokus w skos przy przejściu w dół.
 *
 * Znaki poza alfabetem wybrane z realnych tytułów: dywiz (`Fate/stay night`… właściwie
 * `Re:Zero`), dwukropek, kropka i apostrof pokrywają resztę interpunkcji, jaka
 * pojawia się w nazwach anime.
 */
export const KEY_ROWS: ReadonlyArray<ReadonlyArray<string>> = [
  [...'abcdefghij'],
  [...'klmnopqrst'],
  [..."uvwxyz-:.'"],
  [...'0123456789'],
];

/**
 * Nowa treść pola po naciśnięciu klawisza.
 *
 * Odstęp nie dokłada się do odstępu ani nie zaczyna zapytania. Na pilocie
 * przytrzymanie klawisza to kilka naciśnięć na sekundę, więc „szukam `  frieren`"
 * powstaje samo — a wyszukiwanie po dwóch odstępach nie znajduje nic.
 */
export function applyKey(value: string, action: KeyAction): string {
  switch (action.kind) {
    case 'char':
      return value + action.char;
    case 'space':
      return value.length === 0 || value.endsWith(' ') ? value : `${value} `;
    case 'backspace':
      return value.slice(0, -1);
    case 'clear':
      return '';
  }
}
